module.exports = __webpack_public_path__ + "static/media/applicants.6f3b1a3d.svg";